import { css } from '@emotion/css'
import { colors, fontWeight, spacing } from '@offerzen/pinata-shame'

const styles = {
  select: css({
    width: '100%',
  }),

  sectionHeading: css({
    marginTop: spacing.medium,
    marginBottom: spacing.default,
    fontWeight: fontWeight.bold,
    color: colors.blackPearl,

    ':first-of-type': {
      marginTop: 0,
    },
  }),
}

export default styles
